import { createAction, props } from "@ngrx/store";
import { IErrors } from "../../models/error";

enum TrackingActions {
    // Read A Book
    ReadABook = "[Tracking] Read A Book",
    ReadABookSuccess = "[Tracking] Read A Book Success",
    ReadABookFailure = "[Tracking] Read A Book Failure",

    // Complete A Book
    CompleteABook = "[Tracking] Complete A Book",
    CompleteABookSuccess = "[Tracking] Complete A Book Success",
    CompleteABookFailure = "[Tracking] Complete A Book Failure",

    // Read A Chapter
    ReadAChapter = "[Tracking] Read A Chapter",
    readAChapterSuccess = "[Tracking] Read A Chapter Success",
    readAChapterFailure = "[Tracking] Read A Chapter Failure",

    // Complete A Chapter
    CompleteAChapter = "[Tracking] Complete A Chapter",
    CompleteAChapterSuccess = "[Tracking] Complete A Chapter Success",
    CompleteAChapterFailure = "[Tracking] Complete A Chapter Failure",

    // Read A Page
    ReadAPage = "[Tracking] Read A Page",
    ReadAPageSuccess = "[Tracking] Read A Page Success",
    ReadAPageFailure = "[Tracking] Read A Page Failure"
}

// Read A Book
export const ReadABookAction = createAction(
    TrackingActions.ReadABook,
    props<{ bookId: string }>()
);
export const ReadABookSuccessAction = createAction(
    TrackingActions.ReadABookSuccess);
export const ReadABookFailureAction = createAction(
    TrackingActions.ReadABookFailure,
    props<{ error: IErrors }>()
)

// Complete A Book
export const CompleteABookAction = createAction(
    TrackingActions.CompleteABook,
    props<{ bookId: string }>()
)
export const CompleteABookSuccessAction = createAction(
    TrackingActions.CompleteABookSuccess
)
export const CompleteABookFailureAction = createAction(
    TrackingActions.CompleteABookFailure,
    props<{ error: IErrors }>()
)

// Read A Chapter
export const ReadAChapterAction = createAction(
    TrackingActions.ReadAChapter,
    props<{ chapterId: string, bookId: string, fromChapterChange?: boolean }>()
);
export const ReadAChapterSuccessAction = createAction(
    TrackingActions.readAChapterSuccess,
    props<{ bookId: string, fromChapterChange?: boolean }>()
)
export const ReadAChapterFailureAction = createAction(
    TrackingActions.readAChapterFailure,
    props<{ error: IErrors }>()
)

// Complete A Chapter
export const CompleteAChapterAction = createAction(
    TrackingActions.CompleteAChapter,
    props<{ chapterId: string, bookId: string,  fromChapterChange?: boolean }>()
);
export const CompleteAChapterSuccessAction = createAction(
    TrackingActions.CompleteAChapterSuccess,
    props<{ bookId: string, fromChapterChange?: boolean }>()
)
export const CompleteAChapterFailureAction = createAction(
    TrackingActions.CompleteAChapterFailure,
    props<{ error: IErrors }>()
)

// Read A Page
export const ReadAPageAction = createAction(
    TrackingActions.ReadAPage,
    props<{ pageId: string, timeSpent: number }>()
)
export const ReadAPageSuccessAction = createAction(
    TrackingActions.ReadAPageSuccess
)
export const ReadAPageFailureAction = createAction(
    TrackingActions.ReadAPageFailure,
    props<{ error: IErrors }>()
)
